/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../utils/SkeletonSettings";

export const SearchGridCardSkeleton = (props) => (
    <ContentLoader
        height={310}
        width={`calc(25% - 24px)`}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{marginLeft: "12px", marginRight: "12px"}}
        {...props}>

        {/* Card */}
        <rect x="0" y="15" width="100%" height="100%"/>

    </ContentLoader>
)
